export default __webpack_public_path__ + "static/roca-logo-7fbe722a7e5925d1827f255be512e0df.jpg";